/**
 * Normalize an ID to a string for consistent comparisons.
 * GraphQL returns IDs as strings, socket events send IDs as numbers.
 * This ensures all comparisons use the same type.
 *
 * @param {string|number|null|undefined} id
 * @returns {string|null}
 */
export const normalizeId = (id) => (id != null ? String(id) : null);

/**
 * Compare two IDs for equality regardless of type (string vs number).
 *
 * @param {string|number|null|undefined} id1
 * @param {string|number|null|undefined} id2
 * @returns {boolean}
 */
export const idsMatch = (id1, id2) => {
  if (id1 == null || id2 == null) return false;
  return String(id1) === String(id2);
};
